export default "__VITE_PUBLIC_ASSET__47904612__"